<template>
  <div>
    <HideManifestModal />
    <RestoreManifestModal/>
  </div>
</template>
<script>
import HideManifestModal from "@/components/widgets/Modals/HideManifestModal";
import RestoreManifestModal from "@/components/widgets/Modals/RestoreManifestModal";
export default {
  name: "ManifestActions",
  components: {
    HideManifestModal,
    RestoreManifestModal
  }
};
</script>